import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const matomo = defineConnector({
  identifier: "matomo",
  name: "Matomo",
  tagLine: "Web analytics platform",
  logo,
  protocol: "http",
  tags: ["data", "observability"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.matomo\\.cloud/.*",
  auth: (app) => queryAuth([{ name: "token_auth", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Matomo instance, go to **Settings > Personal > Security**, and copy your API authentication token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Matomo host",
          placeholder: "analytics.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) =>
      `https://${host}/index.php?module=API&method=API.getMatomoVersion&format=json`,
  },
});
